module.exports = __webpack_public_path__ + "static/media/checkMark.1c54083c.svg";